
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/manage/issue",
      function () {
        return require("private-next-pages/ir/manage/issue.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/manage/issue"])
      });
    }
  